module.exports = __webpack_public_path__ + "img/wa.a530bc04.svg";